import { parseDate } from 'utils/datetime';

/**
 * If it's a relative date it will return the date as is otherwise,
 * it will convert the date to a string verson of the epoch time
 */
export const getOnChangeValue = (date: string, isRelativeDate: boolean) =>
  isRelativeDate ? date : parseDate(date).getTime().toString();
